import { Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CargaService } from '@/app/services/carga.service';
import { EquiposService } from '@/app/services/equipos.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { UsuarioService } from '@/app/services/usuario.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-crear-carga',
    templateUrl: './crear-carga.component.html',
    styleUrls: ['./crear-carga.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrearCargaComponent {

  //elements
  @ViewChild('inputFile') inputFile!: ElementRef;
  private spinner = inject(NgxSpinnerService);

  cargaRQ = {
    idOperador: 0,
    idDespachador: 0,
    idEquipo: 0,
    idCombustible:'',
    almacen: '',
    litrosCargados : '',
    horometro: '',
    pathFoto: '',
    fechaCarga:'',
    idEstacion: 0,
    creadoPor:this.userTokenReaderService.getUserData().idUsuario,
    observacion:'',
    idAlmacen:0,
    IATA:''
  };

  //validaciones
  hasFinished: boolean = false;

  equiposValid:boolean = true;
  operadoresValid: boolean = true;
  despachadoresValid:boolean = true;
  isAdmin:boolean=false;

  //catalogos
  estaciones: any[] = [];
  equipos: any[] =[];
  operadores: any[] =[];
  despachadores: any[] = [];

  constructor(
    private userTokenReaderService: TokenReaderService,
    private cargaService: CargaService,
    private toastr: ToastrService,
    private router: Router,
    private estacionesService: EstacionesService,
    private equiposService: EquiposService,
    private usuarioService: UsuarioService,
    public dialogRef: MatDialogRef<CrearCargaComponent>,
  ){
    this.obtenerEstaciones();
    this.getEquipos(this.userTokenReaderService.getUserData().estacion);
    this.getPersonal(this.userTokenReaderService.getUserData().estacion);
    this.isAdmin = this.userTokenReaderService.isAdmin();
  }

  obtenerEstaciones(){
    this.estacionesService.obtenerEstaciones().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estaciones != null){
          this.estaciones = data.Estaciones.map( (i: any) => {return {'label': i.IATA, 'value': i.idEstacion} } );    
        }
      },
      error: (err) => {
        this.estaciones = [];
        console.log(err);
      }
    });
  }

  updateListEquipos(event: any){
    if(event != null && event.value != null && event.value !== ""){
      this.limpiarFormulario();
      this.getEquipos(event.value);
      this.getPersonal(event.value);
    }
  }
  
  updateInfoEquipo(event: any){
    if(event != null && event.value != null){
      let equipoSelected = this.equipos.find(x => x['value'] === event.value);
      this.cargaRQ.almacen = equipoSelected['almacen'];
      this.cargaRQ.idAlmacen = equipoSelected['idAlmacen'];
      this.cargaRQ.idCombustible = equipoSelected['idGasolina'];
    }
  }

  getEquipos(station: string){
    this.limpiarFormulario();
    this.equiposService.getEquipos(station).subscribe({       
      next: (data: any) => {
        if(data != null && data.Equipos != null){
          this.equipos = data.Equipos.map( (i: any) => {return {'label': i.numeroActivo, 'value': i.idEquipo, 
          'idGasolina': i.idCombustible, 'idEstatus': i.idEstatus, 'almacen': i.almacen, 'idAlmacen': i.idAlmacen} } );  
          this.equiposValid = false;  
        }else{
          this.equiposValid = true;
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.equipos = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getPersonal(idEstacion: string){
    this.usuarioService.getUsersTab(idEstacion).subscribe({       
      next: (data: any) => {
        let rolActual = this.userTokenReaderService.getUserData().idRol;

        if(data != null && data.Tipos != null){
          
          if(Array.isArray(data.Tipos.Item1) && data.Tipos.Item1.length > 0){
            this.operadores = data.Tipos.Item1.map( (i : any)=>{return {'label':i.nombre + ' ' + i.apellidoPaterno + " " + i.apellidoMaterno,'value':i.idUsuario,'idRol':i.idRol}});                       
            
            if(rolActual!=1){
              this.operadores = this.operadores.filter( p=> p['idRol']!=1 );
            }
            this.operadoresValid = false;
          }else{
            this.operadoresValid = true;
          }

          if(Array.isArray(data.Tipos.Item2) && data.Tipos.Item2.length > 0 ){
            this.despachadores = data.Tipos.Item2.map((i: any)=>{return {'label':i.nombre + ' ' + i.apellidoPaterno + " " + i.apellidoMaterno,'value':i.idUsuario,'idRol':i.idRol}});              
            
            if(rolActual != 1){
              this.despachadores = this.despachadores.filter(p=>p['idRol']!=1);
            }
            this.despachadoresValid = false;
          }else{
            this.despachadoresValid = true;
          }
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.operadores = [];
          this.despachadores = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear una nueva carga?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.crearCarga();
        }
      });
    }
  }

  crearCarga(){
    this.spinner.show();
    this.cargaRQ.fechaCarga=new Date().toISOString();
    let estacionSelected = this.estaciones.find(x => x['value'] === this.cargaRQ.idEstacion);
    this.cargaRQ.IATA = estacionSelected['label'];

    this.cargaService.insertLoad(this.cargaRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Carga registrada correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) =>{
        this.spinner.hide();
        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else if (err instanceof Error) {
          // Error de validación local: se muestra el mensaje propio, sin detalles del backend.
          this.toastr.error(err.message, 'Dato no válido');
        } else {
          if (err) {
            this.toastr.error('Error al guardar la carga', 'Error');
          }
        }
      }
    });
  }
  
  limpiarFormulario(){
    this.cargaRQ.almacen='';
    this.cargaRQ.idCombustible = '';
    this.cargaRQ.pathFoto = '';
    this.cargaRQ.litrosCargados = '';
    this.cargaRQ.horometro ='';
    this.cargaRQ.idEquipo = 0;
    this.cargaRQ.idOperador = 0;
    this.cargaRQ.idDespachador = 0;
    this.cargaRQ.idEstacion = parseInt(this.userTokenReaderService.getUserData().idEstacion);
  }

  //foto
  changeListener(event: any) : void {
    this.readThis(event.target);
  }
  
  /** Lado máximo (px) de la imagen que se envía. Reduce peso sin afectar la lectura del horómetro. */
  private static readonly MAX_LADO_FOTO = 1600;

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    if (!file) {
      return;
    }

    // Se valida por el tipo MIME real del archivo, no por el nombre.
    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      Swal.fire('Error', 'No se puede procesar ese archivo. Solo imagenes.', 'error');
      this.inputFile.nativeElement.value = '';
      return;
    }

    this.sanitizarImagen(file)
      .then((dataUrl) => {
        this.cargaRQ.pathFoto = dataUrl;
      })
      .catch(() => {
        Swal.fire('Error', 'No se pudo procesar la imagen. Intenta con otra foto.', 'error');
        this.inputFile.nativeElement.value = '';
        this.cargaRQ.pathFoto = '';
      });
  }

  /**
   * Re-codifica la imagen dibujándola en un canvas y exportándola de nuevo. El
   * canvas sólo conserva los píxeles, por lo que los metadatos EXIF (que pueden
   * incluir geolocalización, fecha y modelo del dispositivo) se descartan: no se
   * transmiten al backend datos sensibles que la operación no requiere. De paso
   * se limita el tamaño para reducir el volumen de la carga saliente.
   */
  private sanitizarImagen(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('No se pudo leer el archivo.'));
      reader.onload = () => {
        const imagen = new Image();
        imagen.onerror = () => reject(new Error('El archivo no es una imagen válida.'));
        imagen.onload = () => {
          const max = CrearCargaComponent.MAX_LADO_FOTO;
          const escala = Math.min(1, max / Math.max(imagen.width, imagen.height));
          const ancho = Math.max(1, Math.round(imagen.width * escala));
          const alto = Math.max(1, Math.round(imagen.height * escala));

          const canvas = document.createElement('canvas');
          canvas.width = ancho;
          canvas.height = alto;

          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject(new Error('No se pudo procesar la imagen.'));
            return;
          }

          ctx.drawImage(imagen, 0, 0, ancho, alto);
          // Se exporta siempre como JPEG nuevo, sin metadatos del archivo original.
          resolve(canvas.toDataURL('image/jpeg', 0.85));
        };
        imagen.src = String(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado la carga. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }
  }

}
